import React, { useEffect, useState } from "react";
import { CompressImageFile } from "../components/CompressImageFile";
import { getApiUrl } from '../hooks/useAuth';
import { ToastContainer, toast } from 'react-toastify';
import { useAuth } from '../hooks/useAuth';
export default function Sops() {
     const [filter, setFilter] = useState("");
     const [sops, setSops] = useState([]);
     const [page, setPage] = useState(1);
     const [totalPages, setTotalPages] = useState(1);
     const [loading, setLoading] = useState(false);
     const [showCreate, setShowCreate] = useState(false);
     const [newSop, setNewSop] = useState({ title: "", description: "" });
     const [error, setError] = useState("");
     const [fileMessage, setFileMessage] = useState('');
     const fetchSops = async () => {
          setLoading(true);
          setError("");
          try {
               const data = await getSops(filter, page);
               setSops(data.items);
               setTotalPages(data.totalPages);
          } catch (e) {
               setError(e.message);
          }
          setLoading(false);
     };

     const token = sessionStorage.getItem('authToken') || sessionStorage.getItem('token');
     const { isAdmin, isSuperAdmin } = useAuth();
     const LIST_URL = getApiUrl('/getSops');
     const CREATE_URL = getApiUrl('/createSop');


     // Use process.env for Create React App, fallback to your default
     const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost/radiology_badges/api';

     const PAGE_SIZE = 5;
     const getSops = async (filter, page) => {
          const params = new URLSearchParams();
          if (filter) params.append('filter', filter);
          if (page) params.append('page', page);
          params.append('pageSize', PAGE_SIZE);

          const res = await fetch(`${LIST_URL}?${params.toString()}`, {
               headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
               }
          });
          if (!res.ok) throw new Error("Failed to fetch SOPs");
          const data = await res.json();
          const all = Array.isArray(data.data) ? data.data : [];
          const filtered = filter
               ? all.filter(sop =>
                    (sop.title || '').toLowerCase().includes(filter.toLowerCase()) ||
                    (sop.description || '').toLowerCase().includes(filter.toLowerCase())
               )
               : all;
          const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
          const items = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
          return { items, totalPages };
     };

     const createSop = async (data) => {
          const formData = new FormData();
          formData.append('data', JSON.stringify({
               title: data.title,
               description: data.description
          }));
          if (data.file) {
               formData.append('files[0]', data.file);
          }

          const res = await fetch(`${CREATE_URL}`, {
               method: "POST",
               headers: {
                    "Authorization": `Bearer ${token}`,
                    // Do NOT set Content-Type, browser will set it for FormData
                    "Accept": "application/json"
               },
               body: formData,
          });
          if (!res.ok) throw new Error("Failed to create SOP");
          toast.success("SOP created successfully");
          return res.json();
     };

     useEffect(() => {
          fetchSops();
          // eslint-disable-next-line
     }, [filter, page]);

     const handleCreate = async (e) => {
          e.preventDefault();
          setError("");
          try {
               await createSop(newSop);
               setShowCreate(false);
               setNewSop({ title: "", description: "" });
               fetchSops();
          } catch (e) {
               setError(e.message);
          }
     };

     const handleFileInput = async (e) => {
          const file = e.target.files[0];
          setFileMessage('');
          if (!file) return;

          const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
          const MAX_IMAGE_MB = 2;
          const MAX_PDF_MB = 5;

          if (!validTypes.includes(file.type)) {
               setNewSop(s => ({ ...s, file: null, preview: null }));
               setFileMessage('Only JPG, PNG, or PDF allowed');
               return;
          }

          // PDF
          if (file.type === 'application/pdf') {
               if (file.size / 1024 / 1024 > MAX_PDF_MB) {
                    setNewSop(s => ({ ...s, file: null, preview: null }));
                    setFileMessage('PDF exceeds 5MB');
                    return;
               }
               // Optionally validate PDF header here
               // Show PDF icon as preview
               const pdfIcon = 'data:image/svg+xml;base64,' + btoa(`
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
  <polyline points="14,2 14,8 20,8"/>
  <text x="12" y="18" font-family="Arial, sans-serif" font-size="4" text-anchor="middle" fill="#dc3545">PDF</text>
</svg>
`);
               setNewSop(s => ({ ...s, file, preview: pdfIcon }));
               setFileMessage('PDF attached');
               return;
          }

          // Image
          let uploadFile = file;
          let fileSize = file.size / 1024 / 1024;
          if (fileSize > MAX_IMAGE_MB) {
               try {
                    uploadFile = await CompressImageFile(file, MAX_IMAGE_MB - 0.2, 'SOP');
                    fileSize = uploadFile.size / 1024 / 1024;
               } catch (err) {
                    setNewSop(s => ({ ...s, file: null, preview: null }));
                    setFileMessage('Image compression failed');
                    return;
               }
               if (fileSize > MAX_IMAGE_MB) {
                    setNewSop(s => ({ ...s, file: null, preview: null }));
                    setFileMessage('Image too large after compression (max 2MB)');
                    return;
               }
          }
          // Show image preview
          const previewUrl = URL.createObjectURL(uploadFile);
          setNewSop(s => ({ ...s, file: uploadFile, preview: previewUrl }));
          setFileMessage('Image attached');
     };

     // Edit Modal State
     const [showEdit, setShowEdit] = useState(false);
     const [editSop, setEditSop] = useState(null);
     const [editFileMessage, setEditFileMessage] = useState('');

     // Update SOP API
     const updateSop = async (data) => {
          const UPDATE_URL = getApiUrl(`/updateSop/${data.sop_id || data.id}`);
          const formData = new FormData();
          formData.append('data', JSON.stringify({
               sop_id: data.sop_id || data.id,
               title: data.title,
               description: data.description
          }));
          if (data.file) {
               formData.append('files[0]', data.file);
          }
          const res = await fetch(`${UPDATE_URL}`, {
               method: "POST",
               headers: {
                    "Authorization": `Bearer ${token}`,
                    "Accept": "application/json"
               },
               body: formData,
          });
          if (!res.ok) throw new Error("Failed to update SOP");
          toast.success("SOP updated successfully");
          return res.json();
     };

     // Edit file input handler
     const handleEditFileInput = async (e) => {
          const file = e.target.files[0];
          setEditFileMessage('');
          if (!file) return;

          const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
          const MAX_IMAGE_MB = 2;
          const MAX_PDF_MB = 5;

          if (!validTypes.includes(file.type)) {
               setEditSop(s => ({ ...s, file: null, preview: null }));
               setEditFileMessage('Only JPG, PNG, or PDF allowed');
               return;
          }

          // PDF
          if (file.type === 'application/pdf') {
               if (file.size / 1024 / 1024 > MAX_PDF_MB) {
                    setEditSop(s => ({ ...s, file: null, preview: null }));
                    setEditFileMessage('PDF exceeds 5MB');
                    return;
               }
               const pdfIcon = 'data:image/svg+xml;base64,' + btoa(`
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
  <polyline points="14,2 14,8 20,8"/>
  <text x="12" y="18" font-family="Arial, sans-serif" font-size="4" text-anchor="middle" fill="#dc3545">PDF</text>
</svg>
`);
               setEditSop(s => ({ ...s, file, preview: pdfIcon }));
               setEditFileMessage('PDF attached');
               return;
          }

          // Image
          let uploadFile = file;
          let fileSize = file.size / 1024 / 1024;
          if (fileSize > MAX_IMAGE_MB) {
               try {
                    uploadFile = await CompressImageFile(file, MAX_IMAGE_MB - 0.2, 'SOP');
                    fileSize = uploadFile.size / 1024 / 1024;
               } catch (err) {
                    setEditSop(s => ({ ...s, file: null, preview: null }));
                    setEditFileMessage('Image compression failed');
                    return;
               }
               if (fileSize > MAX_IMAGE_MB) {
                    setEditSop(s => ({ ...s, file: null, preview: null }));
                    setEditFileMessage('Image too large after compression (max 2MB)');
                    return;
               }
          }
          const previewUrl = URL.createObjectURL(uploadFile);
          setEditSop(s => ({ ...s, file: uploadFile, preview: previewUrl }));
          setEditFileMessage('Image attached');
     };

     // Handle edit submit
     const handleEdit = async (e) => {
          e.preventDefault();
          setError("");
          try {
               await updateSop(editSop);
               setShowEdit(false);
               setEditSop(null);
               fetchSops();
          } catch (e) {
               setError(e.message);
          }
     };

     return (
          <div style={{ padding: "2rem" }}>
               <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
               <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">SOP Management</h1>
                    <div className="d-flex align-items-center">
                         <input
                              type="text"
                              className="form-control"
                              style={{ width: 300 }}
                              placeholder="Search"
                              value={filter}
                              onChange={(e) => {
                                   setPage(1);
                                   setFilter(e.target.value);
                              }}
                         />
                         <button
                              className="btn btn-primary ml-3"
                              onClick={() => setShowCreate(true)}
                         >
                              <i className="fas fa-plus mr-2"></i>
                              Add New SOP
                         </button>
                    </div>
               </div>

               {error && (
                    <div className="alert alert-danger">
                         <i className="fas fa-exclamation-triangle mr-2"></i>
                         {error}
                    </div>
               )}

               {loading && (
                    <div className="alert alert-info">
                         <span
                              className="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true"
                         ></span>
                         Loading SOPs...
                    </div>
               )}

               {/* Create SOP Modal */}
               {showCreate && (
                    <div
                         className="modal"
                         style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                         <div className="modal-dialog modal-lg">
                              <div className="modal-content">
                                   <div className="modal-header">
                                        <h5 className="modal-title">Add New SOP</h5>
                                        <button
                                             type="button"
                                             className="close"
                                             onClick={() => {
                                                  setShowCreate(false);
                                                  setNewSop({ title: "", description: "" });
                                                  setError("");
                                             }}
                                        >
                                             <span>&times;</span>
                                        </button>
                                   </div>
                                   <div className="modal-body">
                                        {error && (
                                             <div className="alert alert-danger py-2">{error}</div>
                                        )}
                                        <form onSubmit={handleCreate}>
                                             <div className="form-group">
                                                  <label>Title</label> <span className="text-danger">*</span>
                                                  <input
                                                       type="text"
                                                       className="form-control"
                                                       value={newSop.title}
                                                       onChange={(e) =>
                                                            setNewSop({ ...newSop, title: e.target.value })
                                                       }
                                                       required
                                                  />
                                             </div>
                                             <div className="form-group">
                                                  <label>Description</label> <span className="text-danger">*</span>
                                                  <textarea
                                                       className="form-control"
                                                       value={newSop.description}
                                                       onChange={(e) =>
                                                            setNewSop({ ...newSop, description: e.target.value })
                                                       }
                                                       required
                                                  />
                                             </div>
                                             {/* file upload */}
                                             <div className="form-group">
                                                  <label>Upload File</label> <span className="text-danger">*</span>
                                                  <input
                                                       type="file"
                                                       className="form-control"
                                                       accept=".jpg,.jpeg,.png,.pdf"
                                                       onChange={handleFileInput}
                                                       required
                                                  />
                                                  {fileMessage && (
                                                       <div className="text-danger small mt-1">{fileMessage}</div>
                                                  )}
                                                  {newSop.preview && (
                                                       <div className="mt-2">
                                                            {newSop.file?.type === 'application/pdf' ? (
                                                                 <img src={newSop.preview} alt="PDF" style={{ width: 40, height: 40 }} />
                                                            ) : (
                                                                 <img src={newSop.preview} alt="Preview" style={{ maxWidth: 50, maxHeight: 50, border: '1px solid #ccc' }} />
                                                            )}
                                                       </div>
                                                  )}
                                             </div>
                                             <div className="modal-footer px-0">
                                                  <button
                                                       type="button"
                                                       className="btn btn-secondary"
                                                       onClick={() => {
                                                            setShowCreate(false);
                                                            setNewSop({ title: "", description: "" });
                                                            setError("");
                                                       }}
                                                  >
                                                       Cancel
                                                  </button>
                                                  <button type="submit" className="btn btn-primary">
                                                       <i className="fas fa-save mr-2" />
                                                       Create SOP
                                                  </button>
                                             </div>
                                        </form>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}

               {/* Edit SOP Modal */}
               {showEdit && editSop && (
                    <div
                         className="modal"
                         style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                         <div className="modal-dialog modal-lg">
                              <div className="modal-content">
                                   <div className="modal-header">
                                        <h5 className="modal-title">Edit SOP</h5>
                                        <button
                                             type="button"
                                             className="close"
                                             onClick={() => {
                                                  setShowEdit(false);
                                                  setEditSop(null);
                                                  setError("");
                                                  setEditFileMessage('');
                                             }}
                                        >
                                             <span>&times;</span>
                                        </button>
                                   </div>
                                   <div className="modal-body">
                                        {error && (
                                             <div className="alert alert-danger py-2">{error}</div>
                                        )}
                                        <form onSubmit={handleEdit}>
                                             <div className="form-group">
                                                  <label>Title</label> <span className="text-danger">*</span>
                                                  <input
                                                       type="text"
                                                       className="form-control"
                                                       value={editSop.title}
                                                       onChange={(e) =>
                                                            setEditSop({ ...editSop, title: e.target.value })
                                                       }
                                                       required
                                                  />
                                             </div>
                                             <div className="form-group">
                                                  <label>Description</label> <span className="text-danger">*</span>
                                                  <textarea
                                                       className="form-control"
                                                       value={editSop.description}
                                                       onChange={(e) =>
                                                            setEditSop({ ...editSop, description: e.target.value })
                                                       }
                                                       required
                                                  />
                                             </div>
                                             {/* file upload */}
                                             <div className="form-group">
                                                  <label>Replace File</label>
                                                  <input
                                                       type="file"
                                                       className="form-control"
                                                       accept=".jpg,.jpeg,.png,.pdf"
                                                       onChange={handleEditFileInput}
                                                  />
                                                  {editFileMessage && (
                                                       <div className="text-danger small mt-1">{editFileMessage}</div>
                                                  )}
                                                  {editSop.preview ? (
                                                       <div className="mt-2">
                                                            {editSop.file?.type === 'application/pdf' ? (
                                                                 <img src={editSop.preview} alt="PDF" style={{ width: 40, height: 40 }} />
                                                            ) : (
                                                                 <img src={editSop.preview} alt="Preview" style={{ maxWidth: 50, maxHeight: 50, border: '1px solid #ccc' }} />
                                                            )}
                                                       </div>
                                                  ) : editSop.file_path ? (
                                                       <div className="mt-2">
                                                            {/\.(jpe?g|png)$/i.test(editSop.file_path) ? (
                                                                 <img
                                                                      src={
                                                                           editSop.file_path.startsWith('http')
                                                                                ? editSop.file_path
                                                                                : editSop.file_path.startsWith('/uploads/')
                                                                                     ? `${BASE_URL}${editSop.file_path}`
                                                                                     : `${BASE_URL}/${editSop.file_path.replace(/^\/+/, '')}`
                                                                      }
                                                                      alt={editSop.title ? `SOP: ${editSop.title}` : "SOP file"}
                                                                      style={{
                                                                           width: 40,
                                                                           height: 40,
                                                                           objectFit: "cover",
                                                                           border: "1px solid #ccc",
                                                                           borderRadius: 4,
                                                                      }}
                                                                 />
                                                            ) : editSop.file_path.toLowerCase().endsWith('.pdf') ? (
                                                                 <iframe
                                                                      src={
                                                                           editSop.file_path.startsWith('http')
                                                                                ? editSop.file_path
                                                                                : editSop.file_path.startsWith('/uploads/')
                                                                                     ? `${BASE_URL}${editSop.file_path}`
                                                                                     : `${BASE_URL}/${editSop.file_path.replace(/^\/+/, '')}`
                                                                      }
                                                                      title={editSop.title ? `SOP: ${editSop.title}` : "SOP PDF"}
                                                                      width="100"
                                                                      height="40"
                                                                      style={{ border: "1px solid #ccc", borderRadius: 4 }}
                                                                 />
                                                            ) : null}
                                                       </div>
                                                  ) : null}
                                             </div>
                                             <div className="modal-footer px-0">
                                                  <button
                                                       type="button"
                                                       className="btn btn-secondary"
                                                       onClick={() => {
                                                            setShowEdit(false);
                                                            setEditSop(null);
                                                            setError("");
                                                            setEditFileMessage('');
                                                       }}
                                                  >
                                                       Cancel
                                                  </button>
                                                  <button type="submit" className="btn btn-primary">
                                                       <i className="fas fa-save mr-2" />
                                                       Save Changes
                                                  </button>
                                             </div>
                                        </form>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}

               <div className="card shadow mb-4">
                    <div className="card-header py-3">
                         <h6 className="m-0 font-weight-bold text-primary">All SOPs</h6>
                    </div>
                    <div className="card-body">
                         <div className="table-responsive">
                              <table
                                   className="table table-bordered"
                                   width="100%"
                                   cellSpacing="0"
                              >
                                   <thead>
                                        <tr>
                                             <th>Title</th>
                                             <th>Description</th>
                                             <th>File</th>
                                             {/* do not allow show this column for technicians */}
                                             <th> </th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {sops.length === 0 ? (
                                             <tr>
                                                  <td colSpan={4} className="text-center p-4">
                                                       No SOPs found.
                                                  </td>
                                             </tr>
                                        ) : (
                                             sops.map((sop) => (
                                                  <tr key={sop.sop_id || sop.id}>
                                                       <td>{sop.title}</td>
                                                       <td>{sop.description}</td>
                                                       <td>
                                                            {sop.file_path && (
                                                                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                      {/* Preview */}
                                                                      {/\.(jpe?g|png)$/i.test(sop.file_path) ? (
                                                                           <img
                                                                                src={
                                                                                     sop.file_path.startsWith('http')
                                                                                          ? sop.file_path
                                                                                          : sop.file_path.startsWith('/uploads/')
                                                                                               ? `${BASE_URL}${sop.file_path}`
                                                                                               : `${BASE_URL}/${sop.file_path.replace(/^\/+/, '')}`
                                                                                }
                                                                                alt={sop.title ? `SOP: ${sop.title}` : "SOP file"}
                                                                                style={{
                                                                                     width: 40,
                                                                                     height: 40,
                                                                                     objectFit: "cover",
                                                                                     border: "1px solid #ccc",
                                                                                     borderRadius: 4,
                                                                                }}
                                                                           />
                                                                      ) : sop.file_path.toLowerCase().endsWith('.pdf') ? (
                                                                           <img
                                                                                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNkYzM1NDUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBkPSJNMTQgMkg2YTIgMiAwIDAgMC0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMi0yVjhoLTZ6Ii8+PHBvbHlsaW5lIHBvaW50cz0iMTQsMiAxNCw4IDIwLDgiLz48dGV4dCB4PSIxMiIgeT0iMTgiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSI0IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjZGMzNTQ1Ij5QREY8L3RleHQ+PC9zdmc+"
                                                                                alt={sop.title ? `SOP: ${sop.title}` : "SOP PDF"}
                                                                                style={{
                                                                                     width: 40,
                                                                                     height: 40,
                                                                                     border: "1px solid #ccc",
                                                                                     borderRadius: 4,
                                                                                     objectFit: "cover"
                                                                                }}
                                                                           />
                                                                      ) : null}
                                                                      {/* View link */}
                                                                      <a
                                                                           href={
                                                                                sop.file_path.startsWith('http')
                                                                                     ? sop.file_path
                                                                                     : sop.file_path.startsWith('/uploads/')
                                                                                          ? `${BASE_URL}${sop.file_path}`
                                                                                          : `${BASE_URL}/${sop.file_path.replace(/^\/+/, '')}`
                                                                           }
                                                                           target="_blank"
                                                                           rel="noopener noreferrer"
                                                                      >
                                                                           View File
                                                                      </a>
                                                                 </div>
                                                            )}
                                                       </td>

                                                       <td>
                                                            {(isAdmin() || isSuperAdmin()) && (
                                                                 <button
                                                                      className="btn btn-sm btn-primary"
                                                                      onClick={() => {
                                                                           setEditSop({
                                                                                ...sop,
                                                                                file: null,
                                                                                preview: null
                                                                           });
                                                                           setShowEdit(true);
                                                                           setEditFileMessage('');
                                                                           setError('');
                                                                      }}
                                                                 >
                                                                      <i className="fas fa-edit" />
                                                                 </button>
                                                            )}
                                                       </td>

                                                  </tr>
                                             ))
                                        )}
                                   </tbody>
                              </table>

                              <nav>
                                   <ul className="pagination mb-0 justify-content-left">
                                        <li className={`page-item${page === 1 ? " disabled" : ""}`}>
                                             <button
                                                  className="page-link"
                                                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                                             >
                                                  &laquo;
                                             </button>
                                        </li>
                                        {[...Array(totalPages)].map((_, idx) => (
                                             <li
                                                  key={idx + 1}
                                                  className={`page-item${page === idx + 1 ? " active" : ""}`}
                                             >
                                                  <button
                                                       className="page-link"
                                                       onClick={() => setPage(idx + 1)}
                                                  >
                                                       {idx + 1}
                                                  </button>
                                             </li>
                                        ))}
                                        <li
                                             className={`page-item${page === totalPages ? " disabled" : ""
                                                  }`}
                                        >
                                             <button
                                                  className="page-link"
                                                  onClick={() =>
                                                       setPage((p) => Math.min(totalPages, p + 1))
                                                  }
                                             >
                                                  &raquo;
                                             </button>
                                        </li>
                                   </ul>
                              </nav>
                         </div>
                    </div>
               </div>
          </div>
     );
}